import NotificationsList from "shared/components/dashboardCommon/notificationsList";

const BuilderNotifications = () => {
  return <NotificationsList pageHeadingSize="large" />;
};

export default BuilderNotifications;
